import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Phone, ChevronDown } from "lucide-react";
import { PHONE_NUMBER } from "../lib/api";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/packages", label: "Holiday Packages", mega: "packages" },
  { to: "/visa", label: "Visa Services", mega: "visa" },
  { to: "/flights", label: "Flights" },
  { to: "/cruise", label: "Cruises" },
  { to: "/honeymoon", label: "Honeymoon" },
  { to: "/corporate", label: "Corporate" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

const DEST = ["Dubai", "Singapore", "Thailand", "Bali", "Maldives", "Mauritius", "Europe", "Australia", "Kashmir", "Kerala", "Goa", "Himachal", "Andaman", "Bhutan", "Nepal", "Vietnam", "Uttarakhand"];
const VISA = ["Singapore", "Dubai", "Vietnam", "Australia", "New Zealand", "USA", "UK", "Schengen", "Japan"];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [mega, setMega] = useState(null);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-lg border-b border-slate-100" data-testid="site-header">
      <div className="container-p flex items-center justify-between h-16 lg:h-20">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <img src="/logo.png" alt="Acchajee Travels" className="h-10 lg:h-12 w-auto mix-blend-multiply" data-testid="header-logo" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1" onMouseLeave={() => setMega(null)}>
          {NAV.map((n) => (
            <div key={n.to} className="relative" onMouseEnter={() => setMega(n.mega || null)}>
              <NavLink to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-medium rounded-full transition flex items-center gap-1 ${isActive ? "text-[#006CE4]" : "text-[#0A2540] hover:text-[#006CE4]"}`
                }>
                {n.label}
                {n.mega && <ChevronDown className="w-3.5 h-3.5" />}
              </NavLink>
            </div>
          ))}
        </nav>

        {/* mega menu */}
        {mega && (
          <div className="hidden lg:block absolute left-0 right-0 top-full bg-white border-t border-slate-100 shadow-xl" onMouseEnter={() => setMega(mega)} onMouseLeave={() => setMega(null)}>
            <div className="container-p py-8 grid grid-cols-4 gap-6">
              {(mega === "packages" ? DEST : VISA).map((d) => (
                <Link key={d} to={mega === "packages" ? `/packages?destination=${encodeURIComponent(d)}` : `/visa/${d.toLowerCase().replace(/\s+/g,'-')}`}
                  className="text-sm text-[#0A2540] hover:text-[#FF7D00] transition"
                  data-testid={`mega-${mega}-${d.toLowerCase().replace(/\s+/g,'-')}`}
                  onClick={() => setMega(null)}>
                  {d}
                </Link>
              ))}
            </div>
          </div>
        )}

        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${PHONE_NUMBER}`} className="flex items-center gap-2 text-sm text-[#0A2540] font-medium" data-testid="header-call">
            <Phone className="w-4 h-4 text-[#FF7D00]" /> {PHONE_NUMBER}
          </a>
          <Link to="/contact" className="btn-primary text-sm px-5 py-2.5" data-testid="header-quote-btn">Get Free Quote</Link>
        </div>

        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100" data-testid="mobile-menu">
          <div className="container-p py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} className="py-2 text-[#0A2540] font-medium" data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}>{n.label}</NavLink>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} className="btn-primary mt-3 justify-center" data-testid="mobile-quote-btn">Get Free Quote</Link>
          </div>
        </div>
      )}
    </header>
  );
}
